import React from 'react';
import { observer } from 'mobx-react';
import { FormField } from '../../../../../../../../../global/form/form-field/form-field';
import { InfoPopover } from '../../../../../../../../../global/info-popover/info-popover';
import { ReplaysPageLayoutOptions } from '../../../../../../../../../../api/custom-pages.dao';
import { DefaultPageViewModel } from '../../../default-page.viewmodel';
import { useReplaysLayout } from './replays-layout.hook';

type IProps = {
    pageVm: DefaultPageViewModel;
    layoutOptions: ReplaysPageLayoutOptions[];
};

export const ReplaysLayoutSection = observer(({ pageVm, layoutOptions }: IProps): JSX.Element => {
    const {
        layoutLabel,
        replaysLayout,
        isGridViewByTrackSelected,
        carouselViewLabel,
        carouselViewInfoMessage,
        replaysDefaultCarouselView,
        carouselViewOptions,
        handleReplaysLayoutChange,
        handleCarouselViewChange
    } = useReplaysLayout(pageVm);

    return (
        <>
            <FormField label={layoutLabel}>
                <select
                    className='oe-form-field__control'
                    value={replaysLayout.value as string}
                    onChange={handleReplaysLayoutChange}
                    data-test-id='replays-layout-select'
                >
                    {layoutOptions.map(value => (
                        <option key={value} value={value}>{value}</option>
                    ))}
                </select>
            </FormField>
            {isGridViewByTrackSelected && (
                <FormField label={
                    <div className='flex m-bottom-6px'>
                        {carouselViewLabel}
                        <InfoPopover className='m-left-8px'>
                            {carouselViewInfoMessage}
                        </InfoPopover>
                    </div>
                }>
                    <select
                        className='oe-form-field__control'
                        value={replaysDefaultCarouselView.value as string}
                        onChange={handleCarouselViewChange}
                        data-test-id='replays-default-carousel-view-select'
                    >
                        {carouselViewOptions.map(({ value, label }) => (
                            <option key={value} value={value}>{label}</option>
                        ))}
                    </select>
                </FormField>
            )}
        </>
    );
});